import { render, staticRenderFns } from "./DcApprovalComplete.vue?vue&type=template&id=9e4fbe7e&scoped=true"
import script from "./DcApprovalComplete.vue?vue&type=script&lang=js"
export * from "./DcApprovalComplete.vue?vue&type=script&lang=js"
import style0 from "./DcApprovalComplete.vue?vue&type=style&index=0&id=9e4fbe7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4fbe7e",
  null
  
)

export default component.exports